export { BreadcrumbsModule } from './breadcrumbs.module';
export { BreadcrumbsService } from './breadcrumbs.service';
export { Breadcrumb } from './breadcrumb.model';



// WEBPACK FOOTER //
// /dist/src/app/ui/breadcrumbs/index.ts